import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {
    states_all: ['newly', 'processing', 'processed', 'checked', 'finished', 'canceled'],
    states_receive: ['newly', 'processing', 'processed',],
    phaseProcessingInfos: ['undo', 'doing', 'done'],
    states_all_no_newly: ['processing', 'processed', 'checked', 'finished', 'canceled'],

    nearRange: [
        { label: utils.formatDate(utils.beginOfDay(new Date())), key: utils.formatDate(utils.beginOfDay(new Date())), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(new Date())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(new Date())) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(1))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(1))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(1))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(1))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(2))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(2))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(2))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(2))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(3))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(3))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(3))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(3))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(4))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(4))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(4))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(4))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(5))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(5))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(5))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(5))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(6))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(6))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(6))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(6))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(7))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(7))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(7))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(7))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(8))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(8))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(8))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(8))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(9))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(9))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(9))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(9))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(10))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(10))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(10))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(10))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(11))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(11))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(11))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(11))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(12))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(12))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(12))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(12))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(13))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(13))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(13))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(13))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(14))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(14))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(14))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(14))) + ' 23:59:59' } },
        { label: utils.formatDate(utils.endOfDay(utils.nextNDay(15))), key: utils.formatDate(utils.endOfDay(utils.nextNDay(15))), condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(14))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(15))) + ' 23:59:59' } }

    ],
    passRange: [
        { label: '1天', key: '1', condition: { passRangeStart: 1, passRangeEnd: 1 } },
        { label: '2天', key: '2', condition: { passRangeStart: 2, passRangeEnd: 2 } },
        { label: '3天', key: '3', condition: { passRangeStart: 3, passRangeEnd: 3 } },
        { label: '4-6天', key: '4-6', condition: { passRangeStart: 4, passRangeEnd: 6 } },
        { label: '7-10天', key: '7-10', condition: { passRangeStart: 7, passRangeEnd: 10 } },
        { label: '11-15天', key: '11-15', condition: { passRangeStart: 11, passRangeEnd: 15 } },
        { label: '>15天', key: '>15', condition: { passRangeStart: 16, passRangeEnd: 1000 } },
        { label: '全部', key: '全部', condition: { passRangeStart: 1, passRangeEnd: 1000 } }
    ],
    scheduleRange: [
        { label: '过期', key: 'overSchedule', condition: { overSchedule: 'yes' } },
        { label: '今天', key: 'schedule' + utils.formatDate(utils.beginOfDay(new Date())), condition: { scheduleAtStartAt: utils.formatDate(utils.beginOfDay(new Date())) + ' 00:00:00', scheduleAtEndAt: utils.formatDate(utils.endOfDay(new Date())) + ' 23:59:59' } },
        { label: '明天', key: 'schedule' + utils.formatDate(utils.endOfDay(utils.nextNDay(1))), condition: { scheduleAtStartAt: utils.formatDate(utils.beginOfDay(utils.nextNDay(1))) + ' 00:00:00', scheduleAtEndAt: utils.formatDate(utils.endOfDay(utils.nextNDay(1))) + ' 23:59:59' } },
        { label: '后天', key: 'schedule' + utils.formatDate(utils.endOfDay(utils.nextNDay(2))), condition: { scheduleAtStartAt: utils.formatDate(utils.beginOfDay(utils.nextNDay(2))) + ' 00:00:00', scheduleAtEndAt: utils.formatDate(utils.endOfDay(utils.nextNDay(2))) + ' 23:59:59' } },
        { label: '更久', key: 'schedule' + utils.formatDate(utils.endOfDay(utils.nextNDay(3))), condition: { scheduleAtStartAt: utils.formatDate(utils.beginOfDay(utils.nextNDay(3))) + ' 00:00:00', scheduleAtEndAt: utils.formatDate(utils.endOfDay(utils.nextNDay(60))) + ' 23:59:59' } },

    ],
    // 2020-12-22
    search(params) {
        return axios.get('/mes/work-orders?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
    },
    // 2020-12-25
    trackingSearch(params) {
        return axios.get('/mes/work-orders/tracking?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
    },
    // 2020-11-23
    findBySerialNo(params) {
        return axios.post('/mes/work-orders/find-by-serial-no', params)
    },
    // 2020-12-21
    findByOrderUuid(params) {
        return axios.get('/mes/work-orders/find-by-order-uuid', params)
    },
    // 2020-12-23
    updateRemark(id, params) {
        return axios.put('/mes/work-orders/' + id + '/update-remark', params)
    },
    // 2020-12-23
    updateFlags(params) {
        return axios.put('/mes/work-orders/update-flags', params)
    },
    // 2021-09-06
    updateSchedule(id, params) {
        return axios.put('/mes/work-orders/' + id + '/update-schedule', params)
    },
    // 2020-12-23
    unDistributeQuantity(phaseId, params) {
        return axios.put('/mes/work-orders/un-distribute-quantity/' + phaseId, params)
    },

    // 2021-09-09
    autoSchedule(params) {
        return axios.put('/mes/work-orders/auto-schedule', params)
    },
    // 2020-12-23
    batchDistribute(params) {
        return axios.put('/mes/work-orders/batch-distribute', params)
    },
    // 2020-12-23
    batchFinish(params) {
        return axios.put('/mes/work-orders/batch-finish', params)
    },
    // 2020-12-23
    batchPrint(params) {
        return axios.put('/mes//work-orders/batch-print', params)
    },
    // 2020-12-23
    findByIds(params) {
        return axios.put('/mes/work-orders/find-by-ids', params)
    },
    //2020-12-23
    exportExcel(params) {
        return axios.get('/mes/work-orders/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
    },
    //2020-12-26
    nearHandCount() {
        return axios.get('/mes/work-orders/near-hand-count');
    },
    //2020-12-26
    overHandCount() {
        return axios.get('/mes/work-orders/over-hand-count');
    },
    //2020-12-27
    processingProductCount() {
        return axios.get('/mes/work-orders/processing-product-count');
    },
    //2020-12-28
    batchScanStart(params) {
        return axios.put('/mes/work-orders/batch-scan-start', params);
    },
    // 2021-01-20 强制收货用
    receiveSearch(params) {
        return axios.get('/mes/work-orders/receive-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
    },
    // 2020-12-28
    pendingQaCount() {
        return axios.get('/mes/work-orders/pending-qa-count');
    },

    // 2021-01-21
    batchForeceReceive(params) {
        return axios.post('/mes/work-orders/batch-forece-receive', params)
    },
    // 2021-01-21
    changeSpecsForeceReceive(params) {
        return axios.put('/mes/work-orders/change-specs-forece-receive', params)
    },
    // 2021-01-30
    inProductionCount(params) {
        return axios.get('/mes/work-orders/in-production-count', params)
    },
    // 2021-02-20
    getPhasePlans(id, params) {
        return axios.get('/mes/work-orders/' + id + '/phase-plans/find-by-order-uuid', params)
    },
    // 2021-09-10
    scheduleAnalyse(params) {
        return axios.get('/mes/work-orders/schedule-analyse', params)
    },
    // 2021-09-11
    scheduleSearchCount(params) {
        return axios.get('/mes/work-orders/schedule-search-count?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
    },
    // 2022-01-18
    reProcessing(id) {
        return axios.put('/mes/work-orders/' + id + '/re-processing')
    },
    // 2023-03-07
    vagueSerialNo(params) {
        return axios.get('/mes/work-orders/vague-serial-no', params)
    },
    // 2020-12-23
    findById(id) {
        return axios.get('/mes/work-orders/' + id);
    },

}

